import {
  TIEOUT_SYNCSCROLL_SOURCEID,
  TIEOUT_SYNCSCROLL_TARGETID,
} from 'constants/feature/statement-content-constants';
import SyncScrollIds from 'models/api/sync-scroll-ids-modal';
import { handleActions } from 'redux-actions';
import { clearSideBySideElementsMap } from 'store/actions/action-creators';
import {
  clearStatementPageStoreAction,
  setSourceSyncScrollId,
  setTargetSyncScrollId,
} from 'store/actions/statement-content-actions';

const clearDomIdsFromSessionStorage = () => {
  sessionStorage.removeItem(TIEOUT_SYNCSCROLL_SOURCEID);
  sessionStorage.removeItem(TIEOUT_SYNCSCROLL_TARGETID);
};

export default handleActions(
  {
    [setSourceSyncScrollId]: (syncScrollIds, { payload }) => {
      return syncScrollIds.setSourceId(payload);
    },
    [setTargetSyncScrollId]: (syncScrollIds, { payload }) => {
      return syncScrollIds.setTargetId(payload);
    },
    [clearSideBySideElementsMap]: (syncScrollIds) => {
      return syncScrollIds.clearSourceId();
    },
    [clearStatementPageStoreAction]: () => {
      clearDomIdsFromSessionStorage();
      return new SyncScrollIds();
    },
  },
  new SyncScrollIds(),
);
